import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { fonts } from 'styles/fonts';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    flex: 1,
  },
  statusOuterButton: {
    textTransform: 'none',
    fontSize: '13px',
    height: 22,
    borderRadius: 6,
    fontWeight: 500,
    fontFamily: fonts.neue,
  },
  statusButton: {
    minWidth: 150,
    height: 35,
    display: 'flex',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: 'red',
    margin: 5,
    cursor: 'pointer',
    borderRadius: 10,
  },
  circleBox: {
    width: 20,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }

}));

export default useStyles;
